import http from "../http-common";

class NotificationService {
  getNotification(token: any, page: any, pageSize: any, category: any) {
    return http.get(
      `/crm/fcm?pageSize=${pageSize}&page=${page}&category=${category}`,
      {
        headers: {
          authorization: `Bearer ${token}`,
        },
      }
    );
  }

  createNotification(data: any) {
    return http.post(`/crm/fcm`, data);
  }

  sendNotification(id: any, type: string, tokens: any[]) {
    return http.post(`/crm/fcm/${id}`, {
      users: tokens,
      type: type,
    });
  }

  deleteNotification(id: any) {
    return http.delete(`/crm/fcm/${id}`);
  }

  getAllUsers() {
    return http.get(`/crm/fcm/users/portal`);
  }

  createNotifcationEvent(data: any) {
    return http.post(`/crm/scheduled-notification`, data);
  }

  getNotificationLogs() {
    return http.get(`/crm/scheduled-notification`);
  }

  getWhatsappTemplates() {
    return http.get(`/crm/fcm/whatsapp`);
    // return http.get(
    //   `/whatsapp-template/notification?page=${page}&pageSize=${pageSize}`
    // );
  }

  getNotificationById(id: any) {
    return http.get(`/crm/fcm/${id}`);
  }

  updateNotificationById(id: any, data: any) {
    return http.put(`/crm/fcm/${id}`, data);
  }

  getEmailTemplates(page: any, pageSize: any, category: any) {
    return http.get(
      `/crm/email-template?page=${page}&pageSize=${pageSize}&category=${category}`
    );
  }

  updateEmailTemplate(id: any, variable_values: any) {
    return http.patch(`/crm/email-template/${id}`, {
      variable_values,
    });
  }

  updateWhatsappTemplate(id: any, image_url: any, variable_values: any) {
    return http.patch(`/crm/whatsapp-template/${id}`, {
      image_url,
      variable_values,
    });
  }

  sendDolphinActionNotification(
    type?: any,
    notificationId?: any,
    userid?: any,
    app_user_id?: any,
    // whatsapp_variables?: any,
    // whatsapp_image_url?: any
  ) {
    return http.post(`/crm/internal/sent-notification`, {
      type,
      notificationId,
      userid,
      app_user_id,
      // whatsapp_variables,
      // whatsapp_image_url,
    });
  }

  uploadedImageUrl(userId: any, fileName: any, fileData: File) {
    const file = new FormData();

    file.append("image", fileData);
    return http.post(`/crm/images/${userId}?filename=${fileName}`, file, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }

  getImageUrls() {
    return http.get(`/crm/images`);
  }
}
export default new NotificationService();
